import { useInfiniteQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import CoreSearchApi, {
	SearchRequest,
	SearchResponse,
} from '../../api/CoreSearchApi';
import { PAGE_SIZE, SEARCH_QUERY_KEY } from './constants';

const emptyResponse = {
	searchToken: '',
	pageNumber: '',
	results: [],
} as SearchResponse;

export const usePaginatedCoreSearch = (
	authToken: string,
	params: SearchRequest,
) => {
	return useInfiniteQuery(
		[SEARCH_QUERY_KEY, params, authToken, params.searchString],
		async ({
			pageParam = {},
		}: {
			pageParam?: { searchToken?: string; pageNumber?: string };
		}) => {
			if (!params.searchString) {
				return emptyResponse;
			}

			let response: AxiosResponse<SearchResponse>;

			if (!pageParam?.pageNumber) {
				response = await CoreSearchApi.coreSearch(authToken, params);
			} else if (!!pageParam?.pageNumber && !!pageParam?.searchToken) {
				const { searchToken, pageNumber } = pageParam;
				const pageNo = parseInt(pageNumber, 10);

				if (!Number.isInteger(pageNo)) {
					return emptyResponse;
				}

				response = await CoreSearchApi.coreSearchByPage(
					authToken,
					searchToken,
					`${pageNo + 1}`,
				);
			} else {
				return emptyResponse;
			}

			return response.data;
		},
		{
			getPreviousPageParam: (firstPage) =>
				!firstPage?.searchToken || !firstPage?.pageNumber
					? undefined
					: {
							searchToken: firstPage.searchToken,
							pageNumber: firstPage.pageNumber,
					  },
			getNextPageParam: (lastPage) =>
				!lastPage?.searchToken ||
				!lastPage?.pageNumber ||
				lastPage?.results?.length < PAGE_SIZE
					? undefined
					: {
							searchToken: lastPage.searchToken,
							pageNumber: lastPage.pageNumber,
					  },
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
		},
	);
};
